import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {
  type CanvasElementBindings,
  type CanvasElementDataInputPayload,
  type CanvasElementId,
  type IoConfig,
  PropsOf,
} from '@blaze-runtime/engine-domain';
import { RenderElementContext, ViewportMode } from '@blaze-shared/elements-domain';

import {
  CanvasElementComponent,
  type ComponentSlotData,
} from '../../canvas-elements/element-component';
@Component({
  selector: 'be-br',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BreakLineComponent implements CanvasElementComponent<'breakLine'> {
  @Input() elementId: CanvasElementId | undefined;
  @Input() elementContext: RenderElementContext | undefined;
  @Input() elementType!: 'breakLine';
  @Input() ns?: CanvasElementId;
  @Input() props: PropsOf<'breakLine'> | undefined;
  @Input() dataInput: CanvasElementDataInputPayload;
  @Input() bindingResults: CanvasElementBindings = {};
  @Input() ioConfig?: IoConfig;
  @Input() isInEditor = false;
  @Input() slots?: ComponentSlotData<'breakLine'>;
  @Input() visible?: boolean | any[]; // Fixme [MG] It can be an array of whatever "visible" data source will provide
  @Input() viewportMode: ViewportMode | undefined;
}
